<template>
    <CompassTable class="table-loading">
        <CompassTableHead class="table-loading__head">
            <CompassTableHeadCell
                v-for="column in 4"
                :id="column"
                :key="column"
                :defaultWidth="columnsWidth[column]"
            />
        </CompassTableHead>
        <CompassTableBody>
            <CompassTableRow v-for="row in 5" :key="row">
                <CompassTableBodyCell>
                    <CompassSkeleton variant="square" />
                </CompassTableBodyCell>
                <CompassTableBodyCell>
                    <CompassSkeleton />
                </CompassTableBodyCell>
                <CompassTableBodyCell>
                    <CompassSkeleton />
                </CompassTableBodyCell>
                <CompassTableBodyCell>
                    <CompassSkeleton />
                </CompassTableBodyCell>
            </CompassTableRow>
        </CompassTableBody>
    </CompassTable>
</template>
<script setup>
const columnsWidth = [48, 190, 260];
</script>
<style scoped lang="scss">
.table-loading {
    &__head {
        display: none;
    }
    :deep() {
        .compass-table__cell-container,
        .compass-skeleton {
            width: 100%;
        }
        .compass-table-body__row:hover > .compass-table__cell {
            background-color: var(--colors-common-background-default);
        }
    }
}
</style>
